export default __webpack_public_path__ + "static/media/PatrickHand-Regular.ec54a049.ttf";